import store from '../'

let resource = store.defineResource({
  name: "blastBackgrounds"
})

export default resource



// WEBPACK FOOTER //
// ./src/store/models/blastBackgrounds.js